import listActions from 'src/modules/tipoPresupuesto/list/tipoPresupuestoListActions';
import TipoPresupuestoService from 'src/modules/tipoPresupuesto/tipoPresupuestoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'TIPOPRESUPUESTO_DESTROY';

const tipoPresupuestoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoPresupuestoDestroyActions.DESTROY_STARTED,
      });

      await TipoPresupuestoService.destroyAll([id]);

      dispatch({
        type: tipoPresupuestoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoPresupuesto.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/tipo-presupuesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: tipoPresupuestoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: tipoPresupuestoDestroyActions.DESTROY_ALL_STARTED,
      });

      await TipoPresupuestoService.destroyAll(ids);

      dispatch({
        type: tipoPresupuestoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.tipoPresupuesto.destroyAll.success'),
      );

      getHistory().push('/tipo-presupuesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: tipoPresupuestoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default tipoPresupuestoDestroyActions;
